import useVehicleMethods from "components/Hooks/useVehicleMethods";
import { WebsiteVehicleList } from "models/websiteVehicleList";
import { useEffect, useState } from "react";
import { cloudinaryLoaderVehicleImages } from "utils/cloudinaryUtils";
import { numberWithCommas } from "utils/commonUtils";
import useImageUtil from "utils/ImageUtil";
import dynamic from "next/dynamic";

const HtmlComponent = dynamic(() => import("components/Html/Html"));
const Image = dynamic(() => import("next/image"));

const initState: WebsiteVehicleList[] = [];

const SimilarVehicles = ({
    stockNumber,
    options,
    companyInfo,
}: {
    stockNumber: number;
    options: any;
    companyInfo: any;
}) => {
    const [data, setData] = useState(initState);
    const { getSimilarVehicles } = useVehicleMethods();

    const {
        defaultImageAsThumbnail,
        stockPhoto,
        forceImageOverSSL,
        showSimilarVehiclesMiles,
        showSimilarVehiclesLocation,
        showSimilarVehiclesPrice,
        showVehicleSlashedPrice,
        overrideSimilarVehiclesPriceByText,
        overrideSimilarVehiclesPriceText,
        useOrbeeAuto,
        idOrbeeAuto,
        showOrbeeInSimilar,
    } = options;


    useEffect(() => {
        const getData = async () => {
            const list = await getSimilarVehicles(Number(stockNumber || 0));
            setData(list);
        };

        getData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const { renderImage } = useImageUtil({
        stockPhoto,
        forceImageOverSSL,
    });

    return (
        <>
            {data?.map((item: WebsiteVehicleList, index: number) => {
                const makePar = item.make.replace("&", "AND").replace(" ", "-").replace('/', '%2F');
                const modelPar = item.model.replace("&", "AND").replace(" ", "-").replace('/', '%2F');
                const urlComplement = `/carsforsale/${item.year}-${makePar}-${modelPar}-${item.lotName}-${item.lotState}-Stock=${item.stockNumber}`;
                const altImage = `${companyInfo.companyName} - Used ${makePar} ${modelPar} ${item.year} ${item.lotName} ${item.trim}`;

                const imageValue = renderImage(
                    item[defaultImageAsThumbnail.toLowerCase()] as string
                );

                return (
                    <div className="item" key={index}>
                        <div className="car-item gray-bg">
                            <div className="car-content col-md-6">
                                <div className="car-image">
                                    <a href={urlComplement}>
                                        <Image
                                            loader={({ src }) => cloudinaryLoaderVehicleImages({ src, shouldResizeImg: item.hasResizedImages })}
                                            src={imageValue}
                                            className="img-responsive"
                                            // layout="responsive"
                                            width={242}
                                            height={136}
                                            alt={altImage}
                                        />
                                    </a>
                                </div>
                            </div>
                            <div className="car-content col-md-6">
                                <div className="row">
                                    <span className="ax-car-values">
                                        <a className="ax-vehicle-title-car" title={`${item.year}, ${item.make}, ${item.model}, ${item.trim}`} href={urlComplement}>
                                            {item.year} {item.make} {item.model} {item.trim}
                                        </a>
                                    </span>
                                    {showSimilarVehiclesMiles && (
                                        <span className="ax-car-values">
                                            {numberWithCommas(Number(item.miles) || 0)} miles
                                        </span>
                                    )}

                                    {showSimilarVehiclesLocation && (
                                        <span className="ax-car-values lotnamecolor">
                                            {item.lotName}
                                        </span>
                                    )}

                                    <div className="price">
                                        {showSimilarVehiclesPrice && (
                                            <>
                                                {showVehicleSlashedPrice &&
                                                    item.slashedPrice &&
                                                    item.slashedPrice > 0 &&
                                                    item.slashedPrice !== item.internetPrice && (
                                                    <span className="old-price">
                                                            ${numberWithCommas(item.slashedPrice)}
                                                    </span>
                                                )}

                                                <span className="new-price">
                                                    {item?.internetPrice > 0
                                                        ? "$" + numberWithCommas(item.internetPrice)
                                                        : "More Details"}
                                                </span>
                                            </>
                                        )}

                                        {!showSimilarVehiclesPrice &&
                                            overrideSimilarVehiclesPriceByText &&
                                            !overrideSimilarVehiclesPriceText && (
                                            <>
                                                {showVehicleSlashedPrice &&
                                                        item.slashedPrice &&
                                                        item.slashedPrice > 0 &&
                                                        item.slashedPrice !== item.internetPrice && (
                                                    <span className="ax-car-values old-price">
                                                                ${numberWithCommas(item.slashedPrice)}
                                                    </span>
                                                )}

                                                <HtmlComponent
                                                    htmlValue={overrideSimilarVehiclesPriceText}
                                                />
                                            </>
                                        )}
                                    </div>
                                </div>
                            </div>
                            {useOrbeeAuto && idOrbeeAuto && showOrbeeInSimilar
                                && <div className="ax-save-favorite-detail" dangerouslySetInnerHTML={{
                                    __html: `<orb data-plugin-id=${idOrbeeAuto}
                                    data-type="favorites-toggle"
                                    data-vin=${item.vin}>
                                </orb>`}} />
                            }
                        </div>
                    </div>
                );
            })}
        </>
    );
};

export default SimilarVehicles;
